import { FlowConfig } from '@/components/SimplifiedSignup/Context/types';

import SubscriptionExtensionScreensConfig from './Screens';

const SubscriptionExtensionFlow: FlowConfig = {
	activeScreenKey: 'account',
	activeScreenConfig: SubscriptionExtensionScreensConfig.account,
	name: 'SubscriptionExtension',
	pageName: 'stripe-sub-extension',
	screens: {
		account: SubscriptionExtensionScreensConfig.account,
		payment: SubscriptionExtensionScreensConfig.payment,
		handoff: SubscriptionExtensionScreensConfig.handoff,
		error: SubscriptionExtensionScreensConfig.error,
	},
	plan: 'yearly',
	allowChurned: true,
	hasFreeTrial: false,
};

export default SubscriptionExtensionFlow;
